import React from 'react';
import classNames from 'classnames';
import styles from './css/TextArea.styl';

/**
 * TextArea Component
 * @param {Object} props Component Properties
 * @returns {JSX} Text Area JSX
 */
export default class TextArea extends React.Component {
  static propTypes = {
    ariaDescribedBy: React.PropTypes.string,
    ariaLabel: React.PropTypes.string,
    ariaRequired: React.PropTypes.string,
    className: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    handleBlur: React.PropTypes.func,
    handleChange: React.PropTypes.func.isRequired,
    handleFocus: React.PropTypes.func,
    handleKeyUp: React.PropTypes.func,
    id: React.PropTypes.string,
    isInvalid: React.PropTypes.string,
    maxLength: React.PropTypes.number,
    onInit: React.PropTypes.func,
    placeholder: React.PropTypes.string,
    value: React.PropTypes.string.isRequired,
  };

  /**
   * TextArea Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    this.id = props.id ? `${props.id}_textarea` : null;
    this._textArea = null;

    this.setRefTextArea = this.setRefTextArea.bind(this);
  }

  /**
   * Constructs the className string
   * @param  {String}  className  The className prop
   * @param  {Boolean} isDisabled If the component is disabled
   * @param  {Boolean} isInvalid  If the component is inValid
   * @return {String} The classname string
   */
  getClasses(className, isDisabled, isInvalid) {
    const conditionalClasses = {};

    conditionalClasses[styles.disabled] = isDisabled;
    conditionalClasses[styles.error] = isInvalid;

    return classNames(styles.TextArea, className, conditionalClasses);
  }

  /**
   * Setter for textarea ref
   * @param {Element} textArea The text area element
   * @returns {Undefined} Returns nothing
   */
  setRefTextArea(textArea) {
    if (textArea) {
      this._textArea = textArea;
      if (this.props.onInit) {
        this.props.onInit(textArea);
      }
    }
  }

  /**
   * React Component render
   * @return {JSX} TextArea rendered
   */
  render() {
    const className = this.getClasses(
      this.props.className,
      this.props.disabled,
      this.props.isInvalid
    );

    return (
      <textarea
        aria-describedby={this.props.ariaDescribedBy}
        aria-label={this.props.ariaLabel}
        aria-required={this.props.ariaRequired}
        className={className}
        disabled={this.props.disabled}
        id={this.id}
        maxLength={this.props.maxLength}
        onBlur={this.props.handleBlur}
        onChange={this.props.handleChange}
        onFocus={this.props.handleFocus}
        onKeyUp={this.props.handleKeyUp}
        placeholder={this.props.placeholder}
        ref={this.setRefTextArea}
        value={this.props.value}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/FormControls/TextArea.js